export default {
  main: '#A88759',
  secondary: '#000000',
  contrastingColor: '#ffffff',
  priceColor: '#000000',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#ffffff',
};
